export default __webpack_public_path__ + "static/media/thumbs_down.d6508f08.png";